import type { AbstractControl } from '@angular/forms';

/**
 * Returns the first matching message in `messages` keyed by an active validator on `control`, or `undefined` when no
 * message applies. Lets `<cads-form>` and standalone consumers project pre-translated copy through Angular's
 * validator-error map without each call site reimplementing the lookup.
 *
 * Returns `undefined` while the control hasn't been interacted with (`!touched && !dirty`), unless `forceShow` is
 * **true** (typically passed after an attempted submit).
 */
export function pickCadsFormErrorMessage(
  control: AbstractControl | null | undefined,
  messages: Readonly<Record<string, string>> | undefined,
  forceShow = false,
): string | undefined {
  if (!control || !messages || !control.errors) {
    return undefined;
  }
  if (!forceShow && !control.touched && !control.dirty) {
    return undefined;
  }
  for (const validatorKey of Object.keys(control.errors)) {
    const msg = messages[validatorKey];
    if (msg) {
      return msg;
    }
  }
  return undefined;
}
